import React, { Component, Fragment } from 'react';
import MediaQuery from 'react-responsive';

import LoginLoading from './LoginLoading';
import LoginNavBar from './LoginNavBar';
import LoginCard from './LoginCard';
import LoginCardMobile from './LoginCardMobile';
import LoginRedirect from './LoginRedirect';
import LoginHelpDialog from 'navigation/LoginHelpDialog';

import { updateLanguage } from 'react-localize-redux';
import { browserHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { localize } from 'react-localize-redux';
import * as FullStory from '@fullstory/browser';

import Auth from 'j-toker';

import {
  StyledContainer,
  StyledContainerOverlay,
  StyledRow,
  StyledColumn,
} from 'helpers/StyledLoginComponentsHelper';
import { getCurrentLocale, getTranslatedString } from 'helpers/i18n';

import {
  showLoginError,
  toggleAuthenticationDialog,
  logUserIn,
} from 'actions/authenticationActions';
import { setUserAsLead, setUserAsLandlord, setUserAsMaintenance } from 'actions/userTypesActions';
import { showFailureFromUrlQuery } from 'actions/notificationActions';
import { getCompanyPreferences } from 'actions/companyDetailsActions';

import { dashboardForAgent } from 'helpers/RouterHelper';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

let Login = connect(
  store => ({
    showLoginForm: store.authentication.showLoginForm,
    showLoginDialog: store.authentication.showLoginDialog,
    loginMessage: store.userTypes.loginMessage,
    loginAuth: store.userTypes.loginAuth,
    passwordResetURL: store.userTypes.passwordResetURL,
    landlordId: store.userTypes.landlordId,
    email: store.userTypes.email,
    createdSuccess: store.userTypes.createdSuccess,
    userType: store.userTypes.userType,
    heroImageUrl: store.userTypes.heroImageUrl,
  }),
  {
    showLoginError,
    toggleAuthenticationDialog,
    updateLanguage,
    setUserAsLead,
    setUserAsLandlord,
    setUserAsMaintenance,
    logUserIn,
    showFailureFromUrlQuery,
    getCompanyPreferences,
  }
)(
  class Login extends Component {
    constructor(props) {
      super(props);
      this.props = props;
      this.state = {
        username: '',
        password: '',
        mobileNumber: '',
        verificationCode: '',
        verificationMethod: 'mobile',
        isButtonEnabled: true,
        isAuthenticating: false,
        loginHelpOpen: false,
        loginHelpState: 'login',
        mobileNumberInputErrors: {
          required: null,
          validPhone: null,
        },
      };
    }

    componentDidMount() {
      if (this.props.location.query && this.props.location.query.error) {
        this.props.showFailureFromUrlQuery(this.props.location.query.error);
      }
    }

    handleInputChange = event => {
      this.setState({ [event.target.name]: event.target.value.trim() });
    };

    handleMobileNumberChange = value => {
      this.setState({ mobileNumber: value });
    };

    handleVerifyNumber = () => {
      const invalidPhoneVerbiage = getTranslatedString('validationErrors.invalidPhone');
      const requiredErrorVerbiage = getTranslatedString('required');
      const parseResult = parsePhoneNumberFromString(this.state.mobileNumber);
      if (this.state.mobileNumber === '') {
        this.setState(prevState => {
          return {
            ...prevState,
            mobileNumberInputErrors: {
              required: requiredErrorVerbiage,
              validPhone: prevState.mobileNumberInputErrors.validPhone,
            },
          };
        });
      } else if (parseResult && parseResult.isValid()) {
        this.setState(prevState => {
          return {
            ...prevState,
            mobileNumberInputErrors: {
              required: null,
              validPhone: null,
            },
          };
        });
        this.login();
      } else {
        this.setState(prevState => {
          return {
            ...prevState,
            mobileNumberInputErrors: {
              required: prevState.mobileNumberInputErrors.required,
              validPhone: invalidPhoneVerbiage,
            },
          };
        });
      }
    };

    handleLoginHelpOpenClose = openClose => {
      this.setState({
        loginHelpOpen: openClose,
      });
    };

    showAlternative = () => {
      this.props.showLoginError('alternative');
      this.setState({
        loginHelpState: 'alternative',
      });
    };

    login = () => {
      this.setState({ isAuthenticating: true });

      if (this.state.username === '' || this.state.password === '') {
        this.setState({ isAuthenticating: false });
        this.props.showLoginError('blankEmailPasswordError');
        return;
      }

      this.setState({ isButtonEnabled: false });

      const auth = Auth;
      Auth.emailSignIn({
        username: this.state.username,
        password: this.state.password,
        landlord_id: this.props.landlordId,
        mobile_number: this.state.mobileNumber.replace(/[()\\s-]+/gi, ''),
        verification_code: this.state.verificationCode,
        verification_method: this.state.verificationMethod,
        language_code: getCurrentLocale(),
        config: this.props.loginAuth,
      })
        .done(response => {
          auth.configDfd = null;
          if (!this.props.showLoginDialog) {
            this.props.showLoginError(null);
            this.setState({
              loginHelpState: 'login',
            });
          }
          if (
            response.data.id !== undefined &&
            this.props.loginAuth !== 'landlord' &&
            this.props.loginAuth !== 'maintenance'
          ) {
            this.props.setUserAsLead(response.data);
            if (!this.props.showLoginDialog) {
              this.props.router.replace('/dashboard' + browserHistory.getCurrentLocation().search);
            } else {
              this.props.toggleAuthenticationDialog(false);
              this.props.logUserIn();
            }
          } else if (
            response.data.id !== undefined &&
            this.props.loginAuth === 'landlord' &&
            this.props.loginAuth !== 'maintenance'
          ) {
            this.props.setUserAsLandlord(response.data);
            if (!this.props.showLoginDialog) {
              this.props.router.replace(
                dashboardForAgent(response.data.permission) +
                  browserHistory.getCurrentLocation().search
              );
            } else {
              this.props.toggleAuthenticationDialog(false);
              // eslint-disable-next-line
              localStorage.setItem('currentConfigName', '"landlord"');
              this.props.logUserIn();
            }
            if (browserHistory.getCurrentLocation().pathname.startsWith('/companies')) {
              this.props.getCompanyPreferences();
            }
          } else if (
            response.data.id !== undefined &&
            this.props.loginAuth !== 'landlord' &&
            this.props.loginAuth === 'maintenance'
          ) {
            this.props.setUserAsMaintenance(response.data);
            this.props.router.replace(
              '/maintenance/dashboard' + browserHistory.getCurrentLocation().search
            );
          }
          this.handleSuccessfulLogin(response);
        })
        .catch(error => {
          auth.configDfd = null;

          const errorStatus = error.data.error;

          if (errorStatus === 'invalid_credentials') {
            this.props.showLoginError('invalidLoginCredentials');
          } else if (errorStatus === 'blocked_access_from_ip') {
            this.props.showLoginError('blockedAccessFromIp');
          } else if (errorStatus === 'account_locked') {
            // Account locked
            this.props.showLoginError('accountLocked', {
              email: this.state.username,
            });
          } else if (errorStatus === 'unconfirmed') {
            // Uncomfirmed
            this.props.showLoginError('unconfirmedTemp');
            // temporarily showing a different error
            // once we fix email sending, change it back to 'unconfirmed'
            // and remove 'unconfirmedTemp' from global.locale.json
            // this.props.showLoginError('unconfirmed', { email: this.state.username });
          } else if (errorStatus === 'password_expired') {
            // Password expired
            this.props.showLoginError('passwordExpired', {
              email: this.state.email,
              loginHelpState: 'passwordExpired',
            });
          } else if (errorStatus === 'verify_mobile_number') {
            // Verify phone number
            this.setState({
              mobileNumber: error.data.mobile_number,
              loginHelpState: 'validateMobileNumber',
            });
            this.props.showLoginError('verifyMobileNumber', {
              email: this.state.email,
              mobileNumber: error.data.mobile_number,
            });
          } else if (errorStatus === 'verification_code') {
            // Verification token
            this.setState({
              verificationCode: '',
              loginHelpState: 'verificationCode',
            });
            this.props.showLoginError('verificationCode', {
              email: this.state.email,
              mobileNumber: error.data.mobile_number,
            });
          } else {
            this.props.showLoginError('unknownError');
          }
          this.setState({ isButtonEnabled: true, isAuthenticating: false });
        });
    };

    handleSuccessfulLogin(response) {
      this.setState({ isAuthenticating: false });
      let language_code = 'en';
      if (response.data.language_code) {
        language_code = response.data.language_code;
      }
      this.props.updateLanguage(language_code);
      localStorage.setItem('locale', language_code);
      FullStory.identify(response.data.landlord_uuid + response.data.type + response.data.id);
      FullStory.setUserVars({
        email: response.data.email,
        displayName: response.data.landlord_name + "-" + response.data.type + "-" + response.data.first_name,
        landlord_id: response.data.landlord_id,
        landlord_name: response.data.landlord_name,
        user_type: response.data.type,
      });

      if (['production', 'dev', 'qa', 'staging', 'training'].includes(window.ENV)) {
        window.Rollbar.configure({
          payload: {
            person: {
              id: response.data.id, // required
              username: response.data.email,
              email: response.data.email,
            },
          },
        });
      }
    }

    changeVerificationMethod = method => {
      this.setState(
        {
          verificationMethod: method,
        },
        () => {
          this.login();
        }
      );
    };

    resetVerificationCode = () => {
      this.setState({
        verificationCode: '',
      });
      this.login();
    };

    detectEnterKeyDown = event => {
      if (event.key === 'Enter') {
        this.login();
      }
    };

    render() {
      return (
        <Fragment>
          {this._renderDesktop()}
          {this._renderMobile()}
          <LoginHelpDialog
            isOpen={this.state.loginHelpOpen}
            handleClose={() => this.handleLoginHelpOpenClose(false)}
            stage={this.state.loginHelpState}
            loginMessage={this.props.loginMessage}
            passwordResetURL={this.props.passwordResetURL}
          />
        </Fragment>
      );
    }

    _renderDesktop = () => {
      const { showLoginForm, heroImageUrl } = this.props;
      const { isAuthenticating } = this.state;

      return (
        <MediaQuery query="(min-width: 901px)">
          <StyledContainer img={heroImageUrl} ref="appContainer">
            <StyledContainerOverlay img={heroImageUrl}>
              <LoginNavBar
                img={heroImageUrl}
                handleLoginHelpOpenClose={this.handleLoginHelpOpenClose}
                isAuthenticating={isAuthenticating}
              />
              {showLoginForm && (
                <StyledRow>
                  <StyledColumn>
                    <LoginCard
                      details={this.state}
                      login={this.login}
                      handleInputChange={this.handleInputChange}
                      showAlternative={this.showAlternative}
                      changeVerificationMethod={this.changeVerificationMethod}
                      resetVerificationCode={this.resetVerificationCode}
                      detectEnterKeyDown={this.detectEnterKeyDown}
                      isAuthenticating={isAuthenticating}
                      handleMobileNumberChange={this.handleMobileNumberChange}
                      handleVerifyNumber={this.handleVerifyNumber}
                    />
                  </StyledColumn>
                  <StyledColumn>
                    <LoginRedirect img={heroImageUrl} isAuthenticating={isAuthenticating} />
                  </StyledColumn>
                </StyledRow>
              )}
            </StyledContainerOverlay>
          </StyledContainer>
        </MediaQuery>
      );
    };

    _renderMobile = () => {
      const { showLoginForm, heroImageUrl } = this.props;
      const { isAuthenticating } = this.state;

      const showLoginCard = showLoginForm && !isAuthenticating;
      return (
        <MediaQuery query="(max-width: 900px)">
          <StyledContainer ref="appContainer">
            {!isAuthenticating && (
              <LoginNavBar
                mobile
                img={heroImageUrl}
                handleLoginHelpOpenClose={this.handleLoginHelpOpenClose}
              />
            )}
            {isAuthenticating && <LoginLoading img={heroImageUrl} />}

            {showLoginCard && (
              <LoginCardMobile
                details={this.state}
                login={this.login}
                handleInputChange={this.handleInputChange}
                showAlternative={this.showAlternative}
                changeVerificationMethod={this.changeVerificationMethod}
                resetVerificationCode={this.resetVerificationCode}
                detectEnterKeyDown={this.detectEnterKeyDown}
                handleMobileNumberChange={this.handleMobileNumberChange}
                handleVerifyNumber={this.handleVerifyNumber}
              />
            )}
          </StyledContainer>
        </MediaQuery>
      );
    };
  }
);

export default withRouter(localize()(Login));
